import { NotificationsProvider } from '@mantine/notifications';

import isWebView from '~/utils/isWebView';

import useStyles from './AppNotificationsProvider.styles';

export function AppNotificationsProvider({ children }: { children: React.ReactNode }) {
  const webView = isWebView();
  const { classes, cx } = useStyles();

  return (
    <NotificationsProvider className={cx({ [classes.clearOfIntercomLauncher]: !webView })}>
      {children}
    </NotificationsProvider>
  );
}
